import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const GET_BANK_BRANCH_PACKAGE = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getBankBranchPackage',
    operationName: 'getBankBranchPackage',
    args: [
      { name: 'bank_branch_id', type: 'String', required: true },
      { name: 'package_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'bank_branch_id', value: 'bank_branch_id' },
      { name: 'package_id', value: 'package_id' },
    ],
    fields: '{...BankBranchPackageResponseFields}',
    fragments: [Fragments.bankBranchPackageResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const LIST_ALL_BANK_BRANCH_PACKAGES = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listAllBankBranchPackages',
    operationName: 'listAllBankBranchPackages',
    args: [
      { name: 'country', type: 'String', required: true },
      { name: 'limit', type: 'Int' },
      { name: 'offset', type: 'Int' },
    ],
    argsMap: [
      { name: 'country', value: 'country' },
      { name: 'limit', value: 'limit' },
      { name: 'offset', value: 'offset' },
    ],
    fields: '{...BankBranchPackagesListResponseFields}',
    fragments: [Fragments.bankBranchPackagesListResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const LIST_BANKERS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listBankers',
    operationName: 'listBankers',
    args: [
      { name: 'bank_branch_id', type: 'Int' },
      { name: 'search', type: 'String' },
      { name: 'limit', type: 'Int' },
      { name: 'offset', type: 'Int' },
    ],
    argsMap: [
      { name: 'bank_branch_id', value: 'bank_branch_id' },
      { name: 'search', value: 'search' },
      { name: 'limit', value: 'limit' },
      { name: 'offset', value: 'offset' },
    ],
    fields: '{...BankersListResponseFields}',
    fragments: [Fragments.bankersListResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
